<template>
  <div class="cbg-white-container blog-details-main theme--light v-card p-3">
    <div class="col-sm-12 px-0 flex-end mb-2 mob-f-s xs-flex-dir-col">
      <!-- APPROVAL BUTTON -->
      <span v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'">
        <v-btn
          v-if="permissions.includes('CAN_UNPUBLISH_USER_BLOGS')"
          color="success"
          class="ml-2 mr-2"
          @click="openSwal('unpublish', blogDetails._id)"
        >Unpublish</v-btn>
      </span>
      <span v-if="!blogDetails.is_published && blogDetails.status === 'APPROVED'">
        <v-btn
          v-if="permissions.includes('CAN_PUBLISH_USER_BLOGS')"
          color="success"
          class="ml-2 mr-2"
          @click="openSwal('publish', blogDetails._id)"
        >Publish</v-btn>
      </span>

      <span v-if="!blogDetails.is_published && blogDetails.status === 'PENDING'">
        <v-btn
          class="ml-2 mr-2"
          v-if="permissions.includes('CAN_PUBLISH_USER_BLOGS')"
          color="success"
          @click="openSwal('publish', blogDetails._id)"
        >Approve & publish</v-btn>
      </span>
      <span v-if="!blogDetails.is_published && blogDetails.status === 'PENDING'">
        <v-btn
          class="ml-2 mr-2"
          v-if="permissions.includes('CAN_REJECT_USER_BLOGS')"
          color="error"
          @click="openRejectModal(blogDetails._id)"
        >Reject</v-btn>
      </span>
    </div>
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.rejected_reason"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span
        v-if="reasonData.rejected_reason === '' && alert === true"
        class="text-danger required-fields"
      >{{ requiredAlert }}</span>

      <template #header>
        <h6 class="modal-title text-capitalize">Reason for Reject</h6>
      </template>
      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="submitReason()">Submit</v-btn>
      </template>
    </CModal>
    <div class="blog-image">
      <img
        :src="
          blogDetails.cover_photo
            ? blogDetails.cover_photo
            : '/img/avatars/default-user.png'
        "
        alt="user image"
      />
    </div>
    <div class="blog-content-box">
      <h5 class="mt-3 text-capitalize">{{ blogDetails.title }}</h5>
      <p>{{ blogDetails.short_description }}</p>

      <p class="mb-0">
        {{ blogDetails.admin_user_id }}
        <b>{{ getBlogDate(blogDetails.blog_update) }}</b>
      </p>
      <div class="col-sm-12 p-0 blog-links d-just-space my-4 xs-flex-dir-col">
        <div v-if="blogStatus.includes(blogDetails.status) && blogDetails.is_published" class="share-blog d-align ml--12">
          <share-blogs :type="'blog'"></share-blogs>
        </div>
        <div class="mb-2 xss-mt-5">
          <div class="d-flex">
            <div class="blog-count mr-3 d-align">
              <image-view :src="'/img/avatars/visibility.png'" class="mr-1 eye-view"></image-view>
              <p class="mb-0">{{ blogDetails.views_count }}</p>
            </div>
            <div class="blog-count mr-3 d-align" @click="scrollToComment()">
              <image-view :src="'/img/avatars/speech-bubble.png'" class="mr-1"></image-view>
              <p class="mb-0">{{ blogDetails.comments_count }}</p>
            </div>
            <div class="blog-count d-align">
              <image-view :src="'/img/avatars/like.png'" class="mr-1"></image-view>
              <p class="mb-0">{{ blogDetails.likes_count }}</p>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <div class="col-sm-12 p-0">
        <h5 class="text-capitalize">
          <b>Tags</b>
        </h5>
        <div class="chip-list">
          <v-chip
            v-for="(tag, i) in blogDetails.tags"
            :key="i"
            class="text-capitalize cursor mr-2"
            label
          >
            <router-link
              :to="{ name: 'Blogs Listing', params: { tag: tag } }"
              tag="h5"
              class="text-capitalize m-0"
            >{{ tag }}</router-link>
          </v-chip>
        </div>
      </div>
      <hr class="my-4" />
      <p v-html="blogDetails.description"></p>
      <div v-if="blogDetails.comments_count > 0" class="col-sm-12 p-0">
        <div class="d-just-space mb-4" id="comment-count">
          <div class="d-flex">
            <!-- <v-btn color="success" class="mr-4">Comment</v-btn> -->
            <h5 class="m-0">{{ blogDetails.comments_count }} Comments</h5>
          </div>
          <p
            class="m-0 cursor text-capitalize"
            v-if="isShowAllComments"
            @click="showAllComments()"
          >Show all comments</p>

          <p
            class="m-0 cursor text-capitalize"
            v-if="!isShowAllComments"
            @click="showLessComments()"
          >Show less comments</p>
        </div>
      </div>
      <div class="col-sm-12 p-0">
        <div v-for="(comment, i) in commentInfo" :key="i" class="mt-3 border-bottom">
          <p class="mb-0">
            <b>{{ comment.commented_by.full_name }}</b>
          </p>
          <p class="mb-2 text-capitalize">{{ getCommentDate(comment.created_at) }}</p>
          <div class="col-sm-12 p-0 d-flex">
            <div class="col-sm-11 p-0">
              <p class="text-capitalize">{{ comment.comment }}</p>
            </div>
            <div @click="openSwal('delete-comment', comment._id)" class="col-sm-1 py-0 flex-end">
              <deleteSVG class="cursor w-1" />
            </div>
          </div>
        </div>
      </div>
      <pagination
        v-if="showPagination"
        class="pagination-block mt-4"
        :recordPerPage="recordPerPage"
        :currentPage="currentPage"
        :total="total"
        @changePage="changePage"
      />
    </div>
    <loader v-if="showLoader"></loader>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import "@/assets/scss/_blogs.scss";
const Image = () => import("@/components/image.vue");
// const EditImage = () =>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const ShareBlogs = () => import("@/components/modals/shareBlog.vue");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
import { bus } from "@/main.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      reasonData: {
        rejected_reason: ""
      },
      slug: this.$route && this.$route.params && this.$route.params.slug,
      blogTitle:
        this.$route && this.$route.params && this.$route.params.blogTitle,
      blogDetails: {},
      dayJS,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 1,
      total: 0,
      showLoader: false,
      commentNumber: "",
      rejectModal: false,
      reasonModal: false,
      alert: false,
      requiredAlert: "This field is required.",
      blog_id: "",
      commentInfo: [],
      isShowAllComments: true,
      showPagination: false,
      blogStatus: ["APPROVED"]
    };
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  created() {
    localStorage.setItem(
      "currentPathName",
      `/user-blog/${this.slug}${this.blogTitle ? `/${this.blogTitle}` : ""}`
    );
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("currentPathName");
    bus.$emit("CHAT_BREADCRUMB_CHANGE", []);
    next();
  },

  mounted() {
    this.getBlogDetails();
  },

  components: {
    Datepicker,
    "image-view": Image,
    "share-blogs": ShareBlogs,
    ...pickSvg("deleteSVG"),
    pagination: () => import("@/views/common/Pagination"),
    loader
  },

  methods: {
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getComments();
    },

    scrollToComment() {
      const el = document.getElementById("comment-count");
      el.scrollIntoView({ behavior: "smooth" });
    },

    openRejectModal(id) {
      this.rejectModal = true;
      this.blog_id = id;
    },

    submitReason() {
      this.rejectBlog("reject");
    },

    getBlogDetails() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.slug}`;
      this.$http.get(url, {}).then(response => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.blogDetails = { ...response.body.data };
            this.commentInfo = this.blogDetails.comments;
            bus.$emit("CHAT_BREADCRUMB_CHANGE", [
              {
                text: "Home",
                disabled: false,
                to: "/dashboard"
              },
              {
                text: "Blogs Listing",
                disabled: false,
                to: "/user-blog-list"
              },
              {
                text: this.blogDetails.title,
                disabled: true,
                to: this.$route.path
              }
            ]);
          } else {
            this.showLoader = false;
            this.blogDetails = {};
          }
        }
      });
    },
    showAllComments() {
      this.commentInfo = [];
      this.isShowAllComments = false;
      this.getComments();
    },
    showLessComments() {
      this.showPagination = false;
      this.isShowAllComments = true;
      this.commentInfo = [];
      this.getBlogDetails();
    },
    getComments() {
      this.showLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/blog/comment/${this.blogDetails._id}`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage
      };
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          this.showPagination = true;
          this.commentNumber = response.body.data.count;
          if (response.body.data.list) {
            this.commentInfo = response.body.data.list;
            this.totalPage = response.body.data.count / this.recordPerPage;
            if (response.body.data.count % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.count;
          } else {
            this.showPagination = false;
            this.commentInfo = [];
          }
        }
      });
    },
    getBlogDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getCommentDate(date) {
      return dayJS(date).format("DD/MM/YYYY hh:mm a");
    },
    deleteComment(id) {
      let url = `${config.BASE_URL}api/v2/admin/comment/${id}`;
      this.$http.delete(url, {}).then(response => {
        if (!!response.body.status) {
          Swal.fire({
            toast: true,
            html: "<p> <b>" + "Comment Deleted Successfully" + "</b></p>",
            showCancelButton: false,
            showConfirmButton: false,
            position: "bottom",
            customClass: "bottom-swal",
            timer: 6000
          });
        }

        this.getBlogDetails();
      });
    },
    openSwal(status, id) {
      if (status === "delete-comment") {
        Swal.fire({
          title: "Are you sure you want to Delete this comment",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.deleteComment(id);
          }
        });
      } else if (status === "unpublish") {
        Swal.fire({
          title: "Are you sure you want to Unpublish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status, id);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status, id);
          }
        });
      }
    },
    updateBlog(status, id) {
      let cover_photo_name;
      if (this.blogDetails.cover_photo) {
        cover_photo_name = this.blogDetails.cover_photo.split("?")[0];
      }
      let obj = {
        blog_type: "user",
        title: this.blogDetails.title,
        cover_photo: cover_photo_name,
        short_description: this.blogDetails.short_description,
        description: this.blogDetails.description,
        tags: this.blogDetails.tags,
        status: status
      };
      let url;
      if (status === "publish") {
        url = `${config.BASE_URL}api/v2/admin/blogs/${id}/approve`;
        this.$http.put(url, obj).then(response => {
          if (!!response.ok) {
            Swal.fire({
              title: "Blog Published Successfully",

              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/user-blog-list");
              }
            });
          }
        });
      } else {
        url = `${config.BASE_URL}api/v2/admin/blogs/${id}`;
        this.$http.post(url, obj).then(response => {
          if (!!response.ok) {
            Swal.fire({
              title: "Blog Unpublished Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.goTo("/user-blog-list");
              }
            });
          }
        });
      }
    },
    rejectBlog(status) {
      let obj;
      if (this.reasonData.rejected_reason == "") {
        this.alert = true;
        return false;
      } else {
        if (status === "reject") {
          obj = {
            reason: this.reasonData.rejected_reason
          };
        } else {
          obj = {
            is_deleted: true
          };
        }
      }
      console.log(obj);
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blog_id}/reject`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "reject") {
            Swal.fire({
              title: "Blog Rejected",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.rejectModal = false;
                this.goTo("/user-blog-list");
              }
            });
          }
        } else {
          console.log(response);
        }
      });
    },

    goTo(url) {
      this.$router.push(url);
    }
  }
};
</script>